import { render } from "./double.vue?vue&type=template&id=8c00a15c&scoped=true&ts=true"
import script from "./double.vue?vue&type=script&setup=true&lang=ts"
export * from "./double.vue?vue&type=script&setup=true&lang=ts"

import "./style/double-page.less?vue&type=style&index=0&id=8c00a15c&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c00a15c"],['__file',"src/views/browse-view/double.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8c00a15c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8c00a15c', __exports__)) {
    console.log('reload')
    api.reload('8c00a15c', __exports__)
  }
  
  module.hot.accept("./double.vue?vue&type=template&id=8c00a15c&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('8c00a15c', render)
  })

}


export default __exports__